import moment from "jalali-moment";

const RTL_LANGUAGES = ["fa", "ar"];

export const GROUP_KEYS = {
  TODAY: "today",
  YESTERDAY: "yesterday",
  LAST_WEEK: "lastWeek",
  OLDER: "older",
};

// ترتیب نمایش گروه‌ها
export const GROUP_ORDER = [
  GROUP_KEYS.TODAY,
  GROUP_KEYS.YESTERDAY,
  GROUP_KEYS.LAST_WEEK,
  GROUP_KEYS.OLDER,
];

const getGroupKey = (createdAt) => {
  if (!createdAt) return GROUP_KEYS.OLDER;

  const date = moment.utc(createdAt).local();
  const now = moment();

  const diffDays = now.clone().startOf("day").diff(date.clone().startOf("day"), "days");

  if (diffDays <= 0) return GROUP_KEYS.TODAY;
  if (diffDays === 1) return GROUP_KEYS.YESTERDAY;
  if (diffDays <= 7) return GROUP_KEYS.LAST_WEEK;
  return GROUP_KEYS.OLDER;
};

/**
 * conversations رو بر اساس createdAt به گروه‌های زمانی تقسیم می‌کنه.
 * خروجی: [{ key: "today", items: [...] }, { key: "yesterday", items: [...] }, ...]
 * فقط گروه‌هایی که حداقل یه آیتم دارن برگردونده میشن.
 */
export const groupConversationsByDate = (conversations = []) => {
  const buckets = {
    [GROUP_KEYS.TODAY]: [],
    [GROUP_KEYS.YESTERDAY]: [],
    [GROUP_KEYS.LAST_WEEK]: [],
    [GROUP_KEYS.OLDER]: [],
  };

  conversations.forEach((conversation) => {
    const key = getGroupKey(conversation?.createdAt);
    buckets[key].push(conversation);
  });

  return GROUP_ORDER
    .map((key) => ({ key, items: buckets[key] }))
    .filter((group) => group.items.length > 0);
};